import { MKError } from "../../interfaces";
import { MKAzukiRequestEndpoint, MKConstants, MKCustomError } from "../../constants";

/**
 * Azuki request error object.
 * @internal
 */
export class MKAzukiRequestError implements MKError {
    code: string;
    name: string;
    message: string;

    constructor(api: string, code?: number, message?: string) {
        this.name = "MKAzukiRequestError";
        this.code = this.getErrorCode(api, code);
        this.message = message ?? MKCustomError.Unknown.message;
    }

    private getErrorCode(api: string, code?: number): string {
        // template: "4-6{submodule}-{code}"
        const errorCodeTemplate = MKConstants.ErrorCodeTemplate.AzukiError;
        switch(api) {
            case MKAzukiRequestEndpoint.REGISTRATION.API:
                if (code) {
                    return errorCodeTemplate.replace("{submodule}", "1").replace("{code}", code.toString());
                }
                return errorCodeTemplate.replace("{submodule}", "1").replace("{code}", MKCustomError.Unknown.code);

            case MKAzukiRequestEndpoint.ROLL.API:
                if (code) {
                    return errorCodeTemplate.replace("{submodule}", "2").replace("{code}", code.toString());
                }
                return errorCodeTemplate.replace("{submodule}", "2").replace("{code}", MKCustomError.Unknown.code);

            case MKAzukiRequestEndpoint.BEACONS.API:
                if (code) {
                    return errorCodeTemplate.replace("{submodule}", "3").replace("{code}", code.toString());
                }
                return errorCodeTemplate.replace("{submodule}", "3").replace("{code}", MKCustomError.Unknown.code);

            case MKAzukiRequestEndpoint.QUERY.API:
                if (code) {
                    return errorCodeTemplate.replace("{submodule}", "4").replace("{code}", code.toString());
                }
                return errorCodeTemplate.replace("{submodule}", "4").replace("{code}", MKCustomError.Unknown.code);
        }

        return errorCodeTemplate.replace("{submodule}", "0").replace("{code}", MKCustomError.Unknown.code);
    }
}